module.exports = __webpack_public_path__ + "img/7.f526cb18.jpg";